(() => {
  window.dataLayer = window.dataLayer || [];

  const currentScript = document.currentScript;
  const defaultOption = currentScript?.dataset?.defaultConsent || 'granted';

  const readCookie = (name) => {
    const nameEquals = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let index = 0; index < cookies.length; index += 1) {
      const cookie = cookies[index].trim();
      if (cookie.indexOf(nameEquals) === 0) return cookie.substring(nameEquals.length);
    }
    return null;
  };

  const gtag = (...args) => {
    window.dataLayer.push(args);
  };

  const setDefaultGoogleConsent = () => {
    gtag('consent', 'default', {
      ad_storage: defaultOption,
      analytics_storage: defaultOption,
      ad_user_data: defaultOption,
      ad_personalization: defaultOption,
      functionality_storage: defaultOption,
      personalization_storage: defaultOption,
      security_storage: defaultOption,
      wait_for_update: 500,
    });
  };

  try {
    const otCookie = decodeURIComponent(readCookie('OptanonConsent') || '');
    const otGroups = otCookie.split('groups=').pop().split('&')[0];
    const otValues = otGroups.split(',').reduce((accumulator, pair) => {
      const parts = pair.split(':');
      if (parts.length === 2) accumulator[parts[0]] = parts[1];
      return accumulator;
    }, {});

    if (Object.keys(otValues).length > 0) {
      gtag('consent', 'default', {
        ad_storage: otValues.C0004 === '1' ? 'granted' : 'denied',
        analytics_storage: otValues.C0002 === '1' ? 'granted' : 'denied',
        personalization_storage: otValues.C0003 === '1' ? 'granted' : 'denied',
        functionality_storage: otValues.C0003 === '1' ? 'granted' : 'denied',
        ad_personalization: otValues.C0004 === '1' ? 'granted' : 'denied',
        ad_user_data: otValues.C0004 === '1' ? 'granted' : 'denied',
        security_storage: 'granted',
      });
    } else {
      setDefaultGoogleConsent();
    }
  } catch (error) {
    console.error('Consent parsing error:', error);
    setDefaultGoogleConsent();
  }
})();
